import React, { type PropsWithChildren } from 'react';
import { type ProductStates } from '../../../../product-state-machine';
import { type SearchItems } from '../../result-types';
import { useAnalyticsUpdate } from './use-analytics-update';
import { useProductStateAnalytics } from './product-state-analytics';

export type RegisterAnalyticsProps = PropsWithChildren<{
	productState: ProductStates;
	preQueryItems: SearchItems;
	postQueryItems: SearchItems;
}>;

const RegisterAnalytics = ({
	productState,
	preQueryItems,
	postQueryItems,
	children,
}: RegisterAnalyticsProps) => {
	useAnalyticsUpdate(productState);
	useProductStateAnalytics(productState, preQueryItems, postQueryItems);

	return <>{children}</>;
};

export default RegisterAnalytics;
